import {Component, Input, ViewChild, ViewContainerRef, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-group',
  imports: [],
  templateUrl: './group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './group.component.scss',
})
export class GroupComponent {
  @Input() label: string | null = null;

  @ViewChild('container', {read: ViewContainerRef, static: true}) container!: ViewContainerRef;
}
